import Cookies from 'js-cookie'

const TokenKey = '_t'
const USERINfO = 'USERINfO'
const BTNS = 'PERMISSIONBTNS'
const PROUTES = 'PERMISSIONROUTES'

// 用户信息
export function getUserInfo() {
  return localStorage.getItem(USERINfO)
}

export function setUserInfo(data) {
  localStorage.setItem(USERINfO, data)
}

export function removeUserInfo() {
  localStorage.removeItem(USERINfO)
}

// 菜单权限
export function setPrimissionMenu(list) {
  localStorage.setItem(PROUTES, list)
}

export function getPrimissionMenu() {
  return localStorage.getItem(PROUTES)
}

export function removePrimissionMenu() {
  localStorage.removeItem(PROUTES)
}

// 按钮权限
export function setPrimissionBtn(list) {
  localStorage.setItem(BTNS, list)
}

export function getPrimissionBtn() {
  return localStorage.getItem(BTNS)
}

export function removePrimissionBtn() {
  localStorage.removeItem(BTNS)
}

// token
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/store/auth.js